import { csx } from '@vtex/admin-ui'

export const transitionDurationMs = 300
export const DRAWER_ZINDEX = 899 // Less than Toast admin-ui z-index (900)

const styles = {
  drawer: csx({
    position: 'fixed',
    top: 0,
    left: 'auto',
    height: 'full',
    maxWidth: 'full',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    background: '$primary',
    zIndex: DRAWER_ZINDEX,
    boxShadow: '$overlay.center',
    transition: `${transitionDurationMs ?? 0}ms ease-out`,
    visibility: 'visible',
    ':not([open])': {
      visibility: 'hidden',
      transform: 'translate3d(100%, 0, 0)',
    },
    '&.level-0': {
      width: 560,
    },
    '&.level-1': {
      width: 528,
    },
  }),

  closeButton: csx({
    '&': {
      position: 'fixed',
    },
    top: 0,
    right: 0,
    margin: '$space-8',
  }),

  header: csx({
    margin: '$space-8',
    paddingTop: 2,
  }),

  title: csx({
    display: 'block',
  }),

  subtitle: csx({
    paddingTop: '$space-2',
  }),

  footer: csx({
    columnGap: '$space-4',
    justifyContent: 'flex-end',
    padding: '$space-7 $space-8',
    borderTop: '$neutral',
  }),

  content: csx({
    width: 'full',
    overflow: 'auto',
    paddingX: '$space-8',
    paddingY: '$space-2',
    flexGrow: '1',
  }),
  drawerBg: csx({
    zIndex: DRAWER_ZINDEX,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
  }),
}

export default styles
